<div class="px-3">

    <div class="rem-text-default mb-6">
        <div class="flex align-items-center">
    
          <div class="rem-bg-light px-3 py-3 mr-2">
            <i class="pi pi-file font-medium text-xl"></i>
          </div>
          <div>
            <div class="text-2xl font-medium">{{ selectedDataFileMappingType?.Name }} File Mapping for {{ selectedCreditor?.CompanyName }}</div>
            <div class="text-right mt-2">Manage creditor file mapping</div>
          </div>
          
        </div>
      </div>

    <br />
    <div class="flex justify-content-between">
        <div class="flex flex-row gap-3 bottom-padded">
            <p-floatLabel>
                <p-dropdown id="creditors" [disabled]="itemId > 0" [options]="creditors" [(ngModel)]="selectedCreditorId" optionLabel="LongNameWithId" optionValue="CreditorId" placeholder="Select Creditor"></p-dropdown>
                <label for="creditors">Creditor</label>
            </p-floatLabel>
            <p-floatLabel>
                <p-dropdown id="mappingType" [disabled]="itemId > 0" [options]="dataFileMappingTypes" [(ngModel)]="selectedDataFileMappingType" optionLabel="Name" placeholder="Select Mapping Type"></p-dropdown>
                <label for="mappingType">File Mapping Type</label>
            </p-floatLabel>
    
            <remitter-button
                (click)="save()" 
                [label]="getSaveButtonLabel()"
                icon='send'
                [disabled]="(selectedCreditorId == '' || selectedDataFileMappingType == null) || (itemId > 0 && !isDirty)"
                severity='secondary'
            />
    
            <remitter-button
                (click)="addDataFieldMapping()" 
                label='Add New Field Mapping'
                icon='plus'
                severity='info'
                [disabled]="itemId <= 0"
            />
    
            <remitter-button
                (click)="appService.navigateTo('filemappings')" 
                label='Search Mappings'
                icon='search'
            />
            
        </div>
    </div>
    <div class="mt-3">
        <p-tabView (onChange)="handleTabChange($event)">
            <p-tabPanel header="Mappings Editor">
                <br />
                <br />
                <div *ngIf="dataFileMapping">
                    <div *ngFor="let dataFieldMapping of dataFileMapping.FieldMappings">
                        <div class="card-container">
                            <div class="horizontal-flex-alignment">
                                <span title="Field Mapping ID: {{ dataFieldMapping.DataFieldMappingId }}" class="pi pi-sitemap icon"></span>
                                <span *ngIf="dataFieldMapping.IsRequiredOrEncouraged" title="Required / Encouraged Target Field" class="pi pi-star icon"></span>
                                <span *ngIf="!dataFieldMapping.IsRequiredOrEncouraged" title="Optional Target Field" class="pi pi-wrench icon"></span>
                                <div class="bottom-padded">
                                    <p-floatLabel>
                                        <p-dropdown id="dataFieldMappingType" [options]="dataSourceFieldMappingTypes" [(ngModel)]="dataFieldMapping.SourceField.DataSourceFieldMappingTypeId" optionLabel="Name" optionValue="Id" placeholder="Select Field Mapping Type" class="fixed-width-dropdown"></p-dropdown>
                                        <label for="dataFieldMappingType">Source Mapping Type</label>
                                    </p-floatLabel>
                                </div>
                                <div *ngIf="dataFieldMapping.SourceField.DataSourceFieldMappingTypeId != 2" class="bottom-padded">
                                    <p-floatLabel>
                                        <input pInputText id="SourceFieldName" [(ngModel)]="dataFieldMapping.SourceField.Name" placeholder="Field Name" class="standard-input-field" [ngStyle]="{'width.px': dataFieldMapping.SourceField.DataSourceFieldMappingTypeId == 3 ? 192 : 238}" />
                                        <label for="SourceFieldName">Source Field Name</label>
                                    </p-floatLabel>
                                </div>
                                <div *ngIf="dataFieldMapping.SourceField.DataSourceFieldMappingTypeId == 2" class="bottom-padded">
                                    <p-floatLabel>
                                        <input pInputText id="SourceFieldConstantValue" [(ngModel)]="dataFieldMapping.SourceField.ConstantValue" [disabled]="dataFieldMapping.IsRequiredOrEncouraged" placeholder="Constant Value" class="standard-input-field" [ngStyle]="{'width.px': dataFieldMapping.SourceField.DataSourceFieldMappingTypeId == 3 ? 192 : 238}" />
                                        <label for="SourceFieldConstantValue">Source Constant Value</label>
                                    </p-floatLabel>
                                </div>
                                <span title="Show Enumerations (There are currently {{ dataFieldMapping.SourceField.FieldMap.length }})" *ngIf="dataFieldMapping.SourceField.DataSourceFieldMappingTypeId == 3" (click)="toggleEnumerationEditor(dataFieldMapping.SourceField)" class="pi pi-window-maximize icon icon-button" style="width: 46px;">
                                    &nbsp;
                                </span>
                                <p-card [ngClass]="['card', 'pseudo-modal-dialog-card', (dataFieldMapping.SourceField.DataSourceFieldMappingTypeId == 3 && dataFieldMapping.SourceField.IsShowEnumerationEditor) ? 'dialog-div-open' : 'dialog-div-closed']">
                                    <div class="modal-content-container">
                                        <div>
                                            <h1 style="font-weight: bold;">Enumeration Builder</h1>
                                            <h4 style="color: dimgray;">Map values from the <b>{{ dataFieldMapping.SourceField.Name }}</b> field to target values</h4>
                                        </div>
                                        <br />
                                        <div class="enumeration-outer-container">
                                            <div *ngFor="let fieldMappingValue of dataFieldMapping.SourceField.FieldMap" class="enumeration-container bottom-padded">
                                                <p-floatLabel>
                                                    <input pInputText id="SourceValue" [(ngModel)]="fieldMappingValue.SourceValue" placeholder="Source Value" />
                                                    <label for="SourceValue">Source Value</label>
                                                </p-floatLabel>
                                                <span title="Translates To" class="pi pi-caret-right icon"></span>
                                                <p-floatLabel>
                                                    <input pInputText id="TargetValue" [(ngModel)]="fieldMappingValue.TargetValue" placeholder="Target Value" />
                                                    <label for="TargetValue">Target Value</label>
                                                </p-floatLabel>
                                                

                                                <icon-button
                                                    pTooltip='Delete'
                                                    tooltipPosition='left'
                                                    (click)="deleteFieldMappingValue(fieldMappingValue)"
                                                    [icon]="'trash'"
                                                />
                                           
                                            </div>
                                        </div>
                                        <br />
                                        <div style="width:100%;display:flex;justify-content:flex-end;">
    
                                            <remitter-button
                                                (click)="addFieldMappingValue(dataFieldMapping.SourceField)" 
                                                label='Add Enum Mapping'
                                                icon='plus'
                                                severity='info'
                                            />   
                                            
                                            <remitter-button
                                                (click)="toggleEnumerationEditor(dataFieldMapping.SourceField)" 
                                                label='Close'
                                                icon='window-minimize'                                          
                                            />   
    
                                        </div>
                                    </div>
                                </p-card>
                                <span title="Maps to" class="pi pi-caret-right icon"></span>
                                <div class="bottom-padded">
                                    <p-floatLabel>
                                        <input pInputText id="TargetFieldName" [(ngModel)]="dataFieldMapping.TargetFieldName" [disabled]="dataFieldMapping.IsRequiredOrEncouraged" placeholder="Field Name" class="standard-input-field" />
                                        <label for="TargetFieldName">Target Field Name</label>
                                    </p-floatLabel>
                                </div>
                                <div class="bottom-padded">
                                    <p-floatLabel>
                                        <p-dropdown id="stringFormatType" [options]="stringFormatTypes" [(ngModel)]="dataFieldMapping.StringFormatTypeId" optionLabel="Name" optionValue="Id" placeholder="Select String Format Type" class="fixed-width-dropdown">
                                        </p-dropdown>
                                        <label for="stringFormatType">Target Format Type</label>
                                    </p-floatLabel>
                                </div>
                                <span title="Show Advanced Fields" (click)="toggleAdvancedFieldsEditor(dataFieldMapping.SourceField)" class="pi pi-window-maximize icon icon-button" style="width: 46px;">
                                    &nbsp;
                                </span>
                                <p-card [ngClass]="['card', 'pseudo-modal-dialog-card', dataFieldMapping.SourceField.IsShowAdvancedFieldEditor ? 'dialog-div-open' : 'dialog-div-closed']">
                                    <div class="modal-content-container">
                                        <div>
                                            <h1 style="font-weight: bold;">Optional Format fields</h1>
                                            <h4 style="color: dimgray;">Fill-in format values such as 'mm/DD/yyyy' for dates etc</h4>
                                        </div>
                                        <br />
                                        <div style="display:flex;">
                                            <div class="bottom-padded">
                                                <p-floatLabel>
                                                    <input pInputText id="Regex" [(ngModel)]="dataFieldMapping.Regex" placeholder="Regex" class="value-format-expression-field standard-input-field-narrow" />
                                                    <label for="Regex">Regex</label>
                                                </p-floatLabel>
                                            </div>
                                            <div class="bottom-padded">
                                                <p-floatLabel>
                                                    <input pInputText id="DateTimeFormat" [(ngModel)]="dataFieldMapping.DateTimeFormat" placeholder="DateTime Format" class="value-format-expression-field standard-input-field-narrow" />
                                                    <label for="DateTimeFormat">DateTime Format</label>
                                                </p-floatLabel>
                                            </div>
                                            <div class="bottom-padded">
                                                <p-floatLabel>
                                                    <input pInputText id="StringFormat" [(ngModel)]="dataFieldMapping.StringFormat" placeholder="String Format" class="value-format-expression-field standard-input-field-narrow" />
                                                    <label for="String Format">String Format</label>
                                                </p-floatLabel>
                                            </div>
                                            <div class="bottom-padded">
                                                <p-floatLabel>
                                                    <input pInputText id="TimeZone" [(ngModel)]="dataFieldMapping.TimeZone" placeholder="TimeZone" class="value-format-expression-field standard-input-field-narrow" />
                                                    <label for="TimeZone">TimeZone</label>
                                                </p-floatLabel>
                                            </div>
                                        </div>
                                        <br />
                                        <div style="width:100%;display:flex;justify-content:flex-end;">
                                            <remitter-button
                                                (click)="toggleAdvancedFieldsEditor(dataFieldMapping.SourceField)" 
                                                label='Close'
                                                icon='window-minimize'                                          
                                            />   
                                        </div>
                                    </div>
                                </p-card>
                            </div>
                            <icon-button
                              pTooltip='Delete'
                              tooltipPosition='left'
                              (click)="deleteFieldMapping(dataFieldMapping)"
                              [icon]="'trash'"
                            />
                            
                        </div>
                        <br />
                    </div>
                </div>
            </p-tabPanel>
            <p-tabPanel *ngIf="itemId > 0" header="Mappings JSON">
                <br />
                <div>
                    <h1 style="font-weight: bold;">Mapping JSON Raw Data</h1>
                    <h4 style="color: dimgray;">The JSON data below is an artifact for diagnostic purposes only</h4>
                </div>
                <textarea [(ngModel)]="fileMappingJson" name="fileMappingJson" readonly style="font-family:'Courier New';margin-left:8px;width:99%;height:calc(100vh - 390px);overflow:auto;background-color:aliceblue;color:black;">
                </textarea>
            </p-tabPanel>
        </p-tabView>
    </div>
    

</div>